import { usePaymentStore } from '@/stores/payment';
import { type SiteData } from '#shared/types';
import { PageType } from '@zotlo-shared/types/model';

type ProviderSDKPayload = Pick<SiteData, 'providers' | 'preview' | 'page'>;

export const ProviderSdks = {
  data: {} as ProviderSDKPayload,
  init(payload: ProviderSDKPayload) {
    const { providers, preview, page } = payload;
    const paymentStore = usePaymentStore();
    const headScripts = {
      script: [] as any[],
      noscript: [] as any[]
    };
    const isPaymentPage = page?.template?.name === PageType.PAYMENT;

    if (!providers || !isPaymentPage) return headScripts;

    if (providers?.applePay && !preview) {
      const script = {
        async: true,
        crossorigin: true,
        body: true,
        onload: () => paymentStore.onApplePaySdkLoaded(),
        src: 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
      };
      headScripts.script.push(script);
    }

    if (providers?.googlePay && !preview) {
      const script = {
        async: true,
        body: true,
        onload: () => paymentStore.onGooglePayLoaded(),
        src: 'https://pay.google.com/gp/p/js/pay.js'
      };
      headScripts.script.push(script);
    }

    return headScripts;
  }
};
